/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';
import { TravelReportObject } from 'models/allReservations';
import { CostCenter } from 'models/costCenter';

import { Container, Items, Item } from './styles';
import { Company } from 'models/company';
import { AdminUser } from 'models/adminUser';
import { BreakRulesReason } from 'services/travelBreakRulesReasonService';
import { Group } from 'models/group';


interface Product {
    label: string;
    value: string;
  }

interface TravelStatus {
  key: string;
  value: string;
}

interface Props {
  show: boolean;
  value: any;
  allReservations?: TravelReportObject[];
  products?: Product[];
  companies?: Company[];
  users?: AdminUser[];
  costCenters?: CostCenter[];
  breakRuleReasonId?: BreakRulesReason[];
  userGroupId?: Group[];
  travelStatus?: TravelStatus[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: string) => void;
  onClose: () => void;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const SelectGroups = ({ show, companies, products, users, costCenters, breakRuleReasonId, userGroupId, travelStatus, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);

  const isCompanyActive = useCallback((item: Company) => item.id === value, [value]);

  const isCostCenterActive = useCallback((item: CostCenter) => item.id === value, [value]);

  const isUserActive = useCallback((item: AdminUser) => item.id === value, [value]);

  const isProductActive = useCallback((item: Product) => item.value === value, [value]);

  const isBreakRuleReasonIdActive = useCallback((item: BreakRulesReason) => item.id === value, [value]);

  const isUserGroupIdActive = useCallback((item: Group) => item.id === value, [value]);

  const isTravelStatusActive = useCallback((item: TravelStatus) => item === value.key, [value]);

  const handleItemClick = (id: string) => {
    if (id !== value) {
      onChange(id);
    }
    onClose();
  };

  const makeCostCenter = (costCenter: CostCenter) => `${costCenter.code ?? ''} ${costCenter.code ? '-' : ''} ${costCenter.name ?? ''}`;

  const makeCompany = (company: Company) => company.companyName;

  const makeUser = (user: AdminUser) => `${user.name} ${user.lastName}`;

  const makeProduct = (product: Product) => product.label;

  const makeBreakRuleReasonId = (product: BreakRulesReason) => product.name;

  const makeUserGroupId = (product: Group) => product.name;

  const makeTravelStatus = (travel: TravelStatus) => travel.key;

  const makeTravelReport = (travelReport: TravelReportObject) => `${travelReport.travelItineraryId ?? ''} ${travelReport.travelItineraryId ? '-' : ''} ${travelReport.companyName ?? ''}`;

  return show ? (
    <Container>
      <Items>
        {costCenters
          ? costCenters.map((c) => (
            <MakeItem
              key={c.id}
              className={isCostCenterActive(c) ? 'active' : ''}
              text={makeCostCenter(c)}
              onClick={() => handleItemClick(c?.id ?? '')}
            />
          ))
          : companies
          ? companies.map((c) => (
            <MakeItem
              key={c.id}
              className={isCompanyActive(c) ? 'active' : ''}
              text={makeCompany(c)}
              onClick={() => handleItemClick(c.id || '')}
            />
          ))
          :
            users
            ? users.map((u) => (
                <MakeItem
                  key={u.id}
                  className={isUserActive(u) ? 'active' : ''}
                  text={makeUser(u)}
                  onClick={() => handleItemClick(u?.id ?? '')}
                />))
            :
          products ?
          products.map((p) => (
            <MakeItem
              key={p.value}
              className={isProductActive(p) ? 'active' : ''}
              text={makeProduct(p)}
              onClick={() => handleItemClick(p.value || '')}
            />
          ))
          :
          breakRuleReasonId ?
          breakRuleReasonId.map((b) => (
            <MakeItem
              key={b.id}
              className={isBreakRuleReasonIdActive(b) ? 'active' : ''}
              text={makeBreakRuleReasonId(b)}
              onClick={() => handleItemClick(b?.id || '')}
            />
          ))
          :
          travelStatus ?
          travelStatus.map((t) => (
            <MakeItem
              key={t.key}
              className={isTravelStatusActive(t) ? 'active' : ''}
              text={makeTravelStatus(t)}
              onClick={() => handleItemClick(t.key || '')}
            />
          ))
          :
          userGroupId &&
          userGroupId.map((u) => (
            <MakeItem
              key={u.id}
              className={isUserGroupIdActive(u) ? 'active' : ''}
              text={makeUserGroupId(u)}
              onClick={() => handleItemClick(u?.id || '')}
            />
          ))
          }
      </Items>
    </Container>

  ) : null;
};

export default SelectGroups;
